import { withDisplayName } from '@hocs/with-display-name'
import { graphql } from 'gatsby'

const ContentfulContentArticleTab: Utils.EntryFC<
  Queries.ContentfulContentArticleTabFragment
> = ({ content: { imageText } }) => imageText?.text || ''

export const query = graphql`
  fragment ContentfulContentArticleTab on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    imageText {
      text
    }
  }
`

export default withDisplayName(
  ContentfulContentArticleTab,
  'ContentfulContentArticleTab'
)
